import React from 'react';
import '../App.css';
import './PortfolioPage.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';
import { Button } from './Button';


import itforyou from './assets/images/portfolio/itforyou.png';
import axeconstructions from './assets/images/portfolio/axeconstructions.png';
import greenspakuranga from './assets/images/portfolio/greenspakuranga.png';
import interior from './assets/images/portfolio/interior.png';
import loga from './assets/images/portfolio/loga.png';
import luxelectrical from './assets/images/portfolio/luxelectrical.png';
import papadums from './assets/images/portfolio/papadums.png';
import printerneeds from './assets/images/portfolio/printerneeds.png';
import projectmanagement from './assets/images/portfolio/projectmanagement.png';
import resistelectrical from './assets/images/portfolio/Resistelectrical.png';
import savego from './assets/images/portfolio/savego.png';
import senthilmukusha from './assets/images/portfolio/senthilmukusha.png';
import stylecanopies from './assets/images/portfolio/stylecanopies.jpeg';
import treasurekitchen from './assets/images/portfolio/treasurekitchen.png';
import mmgcommunications from './assets/images/portfolio/mmgcommunications.png';
import spotoncleaners from './assets/images/portfolio/spot-oncleaners.png';
import smartkidseducare from './assets/images/portfolio/SmartKidsEducare.png';
import lightspeedpng from './assets/images/portfolio/LightspeedPNG.png';
import lightspeedfiji from './assets/images/portfolio/LightspeedFiji.png';
import ecomigration from './assets/images/portfolio/ecomigration.png';
import smtverification from './assets/images/portfolio/smtverification.png';
import writeng from './assets/images/portfolio/writeng.png';
import littleclimbershb from './assets/images/portfolio/littleclimbershb.png';
import lambspreschool from './assets/images/portfolio/lambspreschool.png';
import dbescivil from './assets/images/portfolio/dbescivil.png';
import dancepiration from './assets/images/portfolio/Dancepiration.webp';
import pacfreshnz from './assets/images/portfolio/pacfreshnz.png';


function PortfolioPage() {
  return (
    <div className='PortfolioSection'>
        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <div class="col-md-6">
            <h1>We design & develop responsive websites.</h1>
            <br />
            <p>This means they can be easily viewed and used across all devices. Be it your phone, computer or iPads, the website automatically fits to the size of your screen, guaranteeing a consistently good user experience.</p>
            </div>
            <div class="col-md-6">
                <div className="parallaxPortfolio"></div>
            </div>
          </div>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInBottom">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-6">
              <h1>Our Recent Projects.</h1>
              <br />
              <p>We are proud of ourselves in being able to work across a number of disciplines from corporate websites to lifestyle & interiors, ecommerce and media & communications.</p>
            </div>
            <div class="col-md-6">
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={pacfreshnz} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>

            <div class="col-md-4">

            <h2>Pacfresh Pacific Produce</h2>
            <p>Pacfresh Pacific Produce is a premium food wholesaler based in New Zealand, specialising in sourcing and supplying high-quality Pacific Island produce. They work closely with trusted growers to deliver fresh, frozen, and value-added products to retailers, food service providers, and wholesalers.</p>
            <a href="https://pacfresh.sslsvc.com/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>

            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
              <h2>Dancepiration</h2>
              <p>Dancepiration NZ brings the joy of Bollywood dance to life with fun classes, exciting workshops, and stunning performances. Whether you’re learning new moves or celebrating a special event, you’ll feel inspired, confident, and part of our dance family.</p>
              <a href="https://dancepiration.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>

            <div class="col-md-8">
              <img src={dancepiration} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={dbescivil} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>

            <div class="col-md-4">

            <h2>DBES Civil</h2>
            <p>DBES Civil is a civil engineering and construction firm based in New Zealand. They specialise in delivering robust infrastructure, earthworks, and site development solutions tailored to residential, commercial, and industrial projects.</p>
            <a href="https://dbescivil.co.nz/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>

            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
              <h2>Lambs PreSchool</h2>
              <p>Lambs Preschool is a childcare centre in Pukekohe, Auckland. At our preschool, children learn through play, explore their creativity, and grow together in a caring environment. We focus on promoting a safe, inclusive, and high-quality learning experience for all children, regardless of age, ability, culture, or background.</p>
              <a href="https://lambspreschool.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>

            <div class="col-md-8">
              <img src={lambspreschool} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
          </div>
        </ScrollAnimation>


        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={smtverification} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>

            <div class="col-md-4">

            <h2>SMT Verification</h2>
            <p>SMT Verification is an engineering consultancy based in Auckland, specialising in structural inspections, producer statements, and building compliance verification across residential, commercial, and infrastructure projects.</p>
            <a href="https://smtverification.com/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
              <h2>WritEng</h2>
              <p>WritEng with Priya is led by Priya Balu, a passionate Global English Teacher and Creative Writing Coach. With over four years of experience and students from more than 20 countries, Priya helps young learners build confidence in grammar, vocabulary, reading, and creative writing.</p>
              <a href="https://writengwithpriya.com/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
          </div>

            <div class="col-md-8">
              <img src={writeng} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={littleclimbershb} alt="iWebDesign Auckland" className="portfolioImage"/>
          </div>

            <div class="col-md-4">
              <h2>Little Climbers Home Based</h2>
              <p>At Little Climbers, we believe early childhood is built on connection, safety, and exploration. In their home-based childcare settings across Auckland, every child receives the care, attention, and space to flourish — not just follow a one-size approach.</p>
              <a href="https://littleclimbers-hb.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
              <h2>Eco Migration</h2>
              <p>Eco Migration is a trusted immigration consultancy based in Auckland. They help individuals and families achieve their dream of living, studying, and working in New Zealand.</p>
              <a href="https://ecomigration.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>

            <div class="col-md-8">
              <img src={ecomigration} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={smartkidseducare} alt="iWebDesign Auckland" className="portfolioImage"/>
          </div>

            <div class="col-md-4">
              <h2>Smart Kids Educare</h2>
              <p>Smart Kids Educare is a Childcare centre in Auckland. At their centre children love each other, learn through observation and grow together as a group. So they aim at promoting a healthy environment and high quality programme for all groups of children irrespective of age, ability, cultures and genders.</p>
              <a href="https://smartkidseducare.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
            <h2>Spot-On Cleaners</h2>
            <p>Reliable & Trustworthy Cleaning Services in Auckland.</p>
              <a href="https://www.spotoncleaners.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>
            <div class="col-md-8">
            <img src={spotoncleaners} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
          </div>
        </ScrollAnimation>



        <ScrollAnimation animateIn="fadeInLeft">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={senthilmukusha} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
            <div class="col-md-4">
            <h2>Senthil & Mukusha</h2>
            <p>Specialise in Immigration Law, Property Law, and Commercial Law.</p>
            <a href="http://www.senthilmukusha.co.nz/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
            <h2>Lightspeed Fiji</h2>
            <p>Official Starlink Reseller in Fiji. They provides exceptional expertise in the deployment of satellite internet, managed services, and video streaming solutions in the Pacific region.</p>
              <a href="https://lightspeed.com.fj/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
            </div>
            <div class="col-md-8">
            <img src={lightspeedfiji} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={mmgcommunications} alt="iWebDesign Auckland" className="portfolioImage"/>
          </div>

            <div class="col-md-4">

            <h2>MMG Communications</h2>
            <p>MMG Communications is a New Zealand registered broadcast and communications firm which owns and operates internet service providers (ISP’s) in New Zealand and Papua New Guinea.</p>
            <a href="https://mmgcommunications.sslsvc.com/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>

            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
            <h2>Lightspeed Papa New Guinea</h2>
            <p>They provides exceptional expertise in the deployment of satellite internet, managed services, and video streaming solutions in Papua New Guinea. With over 1,000+ satisfied managed services clients.</p>
            <a href="https://lightspeedpng.sslsvc.com/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
          </div>

            <div class="col-md-8">
            <img src={lightspeedpng} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
              <img src={stylecanopies} alt="iWebDesign Auckland" className="portfolioImage"/>
            </div>
            <div class="col-md-4">
            <h2>Style Canopies</h2>
            <p>With over 25 years experience within the motor industry specialising in automotive accessories.</p>
            <a href="https://www.stylecanopies.co.nz/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-4">
            <h2>Axe Constructions</h2>
            <p>Axe Constructions Ltd is a highly-specialized constructions company with vast expertise in residential and commercial development.</p>
            <a href="http://axeconstructions.co.nz/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
          </div>

            <div class="col-md-8">
            <img src={axeconstructions} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
          </div>
        </ScrollAnimation>


        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
            <img src={printerneeds} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
            <div class="col-md-4">
            <h2>Printer Needs</h2>
            <p>kiwi owned and operated company that specialises in providing photocopiers and printers.</p>
            <a href="http://printerneeds.co.nz/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
            </div>
          </div>
      </ScrollAnimation>

      <ScrollAnimation animateIn="fadeInLeft">
            <div class="row">
              <br /><br /><br /><br />
              <div class="col-md-4">
              <h2>Papadums</h2>
              <p>The real taste of authentic and traditional South Indian Cuisine.</p>
              <a href="http://www.papadums.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
              </div>
              <div class="col-md-8">
              <img src={papadums} alt="iWebDesign Auckland" className="portfolioImage"/>

              </div>
            </div>
      </ScrollAnimation>

        <ScrollAnimation animateIn="fadeIn">
          <div class="row">
            <br /><br /><br /><br />
            <div class="col-md-8">
            <img src={loga} alt="iWebDesign Auckland" className="portfolioImage"/>

            </div>
            <div class="col-md-4">
            <h2>Loga Pullar</h2>
            <p>The 15 years is a combination of employment with Immigration New Zealand and private consulting services.</p>
            <a href="http://loga.lawyer/" title="iWebDesign Auckland" target="_blank">
              <Button
                className='btns'
                buttonStyle='btn--outline'
                buttonSize='btn--large'
              >
                Visit Website  <i class="fas fa-arrow-right"></i>
              </Button>
            </a>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft">
            <div class="row">
              <br /><br /><br /><br />
              <div class="col-md-4">
              <h2>Treasure Kitchen</h2>
              <p>Authentic Malaysian & Thai Restaurant which locates in Henderson, Auckland.</p>
              <a href="http://treasurekitchen.co.nz/" title="iWebDesign Auckland" target="_blank">
                <Button
                  className='btns'
                  buttonStyle='btn--outline'
                  buttonSize='btn--large'
                >
                  Visit Website  <i class="fas fa-arrow-right"></i>
                </Button>
              </a>
              </div>
              <div class="col-md-8">
                <img src={treasurekitchen} alt="iWebDesign Auckland" className="portfolioImage"/>

              </div>
            </div>
        </ScrollAnimation>
    </div>
  );
}

export default PortfolioPage
